import DOMPurify from 'dompurify';

// xss-filter
const purifyHTML = (encodedHtml) => DOMPurify.sanitize(encodedHtml);

export default purifyHTML;